var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8247e5",
    d: "M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88.234 47.663c-1.695-.967-3.875-.967-5.812 0L68.86 55.642l-9.203 5.078-13.32 7.979c-1.695.967-3.875.967-5.812 0l-10.414-6.287c-1.695-.967-2.906-2.902-2.906-5.078v-12.09c0-1.934.969-3.869 2.906-5.078l10.414-6.045c1.695-.967 3.875-.967 5.813 0l10.414 6.287c1.695.967 2.906 2.901 2.906 5.078v7.979l9.203-5.319v-8.221c0-1.934-.969-3.869-2.906-5.078L46.578 23.484c-1.695-.967-3.875-.967-5.812 0L20.906 35.09C18.969 36.057 18 37.991 18 39.925v22.728c0 1.934.969 3.869 2.906 5.078l19.617 11.364c1.695.967 3.875.967 5.813 0l13.32-7.737 9.203-5.319 13.32-7.737c1.695-.967 3.875-.967 5.813 0l10.414 6.045c1.696.967 2.906 2.901 2.906 5.078v12.09c0 1.934-.968 3.869-2.906 5.078l-10.172 6.045c-1.695.967-3.875.967-5.812 0l-10.414-6.045c-1.695-.967-2.906-2.901-2.906-5.078v-7.737l-9.203 5.319v7.979c0 1.934.969 3.869 2.906 5.078l19.617 11.364c1.695.968 3.875.968 5.813 0l19.618-11.364c1.695-.967 2.906-2.901 2.906-5.078v-22.97c0-1.934-.969-3.869-2.906-5.078L88.234 47.663z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 23h93v81H18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.65e26a43a734f02923583be335b7ce9c.svg";
export { ForwardRef as ReactComponent };